import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import PasswordInput from './PasswordInput';

export default function ClaimAccountModal({ userName, userId, onSuccess, onCancel }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { claimAccount } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);

    const result = await claimAccount(userId, password);

    if (result.success) {
      onSuccess();
    } else {
      setError(result.error);
      setLoading(false);
    }
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  };

  const modalStyle = {
    width: '100%',
    maxWidth: '450px',
    padding: '24px',
    background: '#2a2a2e',
    borderRadius: '8px',
    border: '1px solid #3a3a3e',
    margin: '16px',
  };

  const titleStyle = {
    fontSize: '20px',
    fontWeight: 600,
    marginBottom: '12px',
    color: '#e8e6e3',
  };

  const descriptionStyle = {
    fontSize: '13px',
    color: '#999',
    marginBottom: '20px',
    lineHeight: '1.5',
  };

  const nameDisplayStyle = {
    padding: '10px',
    background: '#1a1a1c',
    border: '1px solid #3a3a3e',
    borderRadius: '4px',
    color: '#e8e6e3',
    fontSize: '14px',
    marginBottom: '16px',
    fontWeight: 500,
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  };

  const errorStyle = {
    padding: '10px',
    background: '#d4726a22',
    border: '1px solid #d4726a44',
    borderRadius: '4px',
    color: '#d4726a',
    fontSize: '13px',
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: '10px',
    marginTop: '20px',
  };

  const buttonStyle = {
    flex: 1,
    padding: '10px',
    border: 'none',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: loading ? 'not-allowed' : 'pointer',
    opacity: loading ? 0.6 : 1,
  };

  const primaryButtonStyle = {
    ...buttonStyle,
    background: '#e8a87c',
    color: '#1a1a1c',
  };

  const secondaryButtonStyle = {
    ...buttonStyle,
    background: 'transparent',
    color: '#999',
    border: '1px solid #3a3a3e',
  };

  return (
    <div style={overlayStyle} onClick={onCancel}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <h2 style={titleStyle}>Claim Your Account</h2>

        <p style={descriptionStyle}>
          Set a password to secure your account and enable login across devices.
        </p>

        <div style={nameDisplayStyle}>
          {userName}
        </div>

        {error && (
          <div style={errorStyle}>{error}</div>
        )}

        <form onSubmit={handleSubmit} style={formStyle}>
          <PasswordInput
            password={password}
            confirmPassword={confirmPassword}
            onPasswordChange={setPassword}
            onConfirmPasswordChange={setConfirmPassword}
            autoFocus={true}
          />

          <div style={buttonContainerStyle}>
            <button
              type="button"
              onClick={onCancel}
              disabled={loading}
              style={secondaryButtonStyle}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              style={primaryButtonStyle}
            >
              {loading ? 'Claiming...' : 'Claim Account'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
